import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";
import { motion } from "framer-motion";
import "./Contact.scss";
import Footer from "../Footer/Footer";

const containerVariants = {
  //initial state
  hide: {
    opacity: 0,
    y: "100vh",
  },
  //animate state
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.5,
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    y: "-100vh",
    transition: { ease: "easeInOut", duration: 0.3 },
  },
};

const contactVariants = {
  //initial state
  hide: {
    opacity: 0,
    y: 50,
  },
  //animate state
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.8,
      duration: 0.7,
      ease: "linear",
    },
  },
};

//for cards spacing
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

const Contact = () => {
  const classes = useStyles();
  return (
    <>
      <motion.section
        className="contact"
        variants={containerVariants}
        initial="hide"
        animate="show"
        exit="exit"
      >
        <div className="container">
          <h1 className="contact-h1 display-6 text-capitalize text-center mt-5 mb-3">
            contact me
          </h1>
          <div className="row">
            <motion.div
              className="col-md-4 offset-4 col-10 mx-auto"
              variants={contactVariants}
            >
              <p className="text-center mt-5 contact-para">
                My inbox is always open. Feel free to contact me.
              </p>
              <a href="mailto:ahmeraltaf67@gmail.com">
                <Button
                  variant="outlined"
                  color="primary"
                  className="contact-btn mt-3"
                  fullWidth
                >
                  ahmeraltaf67@gmail.com
                </Button>
              </a>
            </motion.div>
          </div>
        </div>
        <Footer />
      </motion.section>
    </>
  );
};

export default Contact;
